import Swal from "sweetalert2";

export const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    timer: 3000,
    timerProgressBar: true,
    showConfirmButton: false
});

export const Confirm = Swal.mixin({
    customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger"
    },
    buttonsStyling: false
});

export const Alert = Swal.mixin({
    customClass: {
        confirmButton: "btn btn-success"
    },
    buttonsStyling: false
});